(function () {
  const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;

  //I'm adding this section so I don't have to keep updating this pen every year :-)
  //remove this if you don't need it
  let today = new Date(),
    dd = String(today.getDate()).padStart(2, "0"),
    mm = String(today.getMonth() + 1).padStart(2, "0"),
    yyyy = today.getFullYear(),
    nextYear = yyyy + 1,
    dayMonth = "12/31/",
    birthday = dayMonth + yyyy;

  today = mm + "/" + dd + "/" + yyyy;
  if (today > birthday) {
    birthday = dayMonth + nextYear;
  }
  //end

  // Check if the element with id "countdown" exists
  var countdownDiv = document.getElementById("countdown");

  const countDown = new Date(birthday).getTime();
  if (countdownDiv !== null) {
    console.log("#countdown exists in the DOM");
    const x = setInterval(function () {
      const now = new Date().getTime(),
        distance = countDown - now;

      (document.getElementById("days").innerText = Math.floor(distance / day)),
        (document.getElementById("hours").innerText = Math.floor(
          (distance % day) / hour
        )),
        (document.getElementById("minutes").innerText = Math.floor(
          (distance % hour) / minute
        )),
        (document.getElementById("seconds").innerText = Math.floor(
          (distance % minute) / second
        ));

      //do something later when date is reached
      if (distance < 0) {
        document.getElementById("headline").innerText = "Giveaway Ends!";
        document.getElementById("countdown").style.display = "none";
        document.getElementById("content").style.display = "block";
        clearInterval(x);
      }
      //seconds
    }, 0);
  }
})();

$().ready(function(){
  $('.slick-carousel').slick({
    arrows: true,
    dots: true,
    slidesToShow: 3,
    infinite: true,
    centerMode: true,

     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
         {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: true,
        }
      },
       ]
  });
  $('.slick-carousel-24').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4.3,
    infinite: true,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 3,
    pauseOnHover:true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3.3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
         {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          // centerPadding: '100px',
          slidesToShow: 1,
        }
      }
    ]
  });

 $(function() {
  $('.tranparent-btn').on('click', function() {
    var imageUrl = $(this).data('image');

    var printWindow = window.open('', '');
    printWindow.document.write(`
      <html>
      <head>
        <title>Print Image</title>
        <style>
          body {
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }
          img {
            max-width: 100vw;
            max-height: 100vh;
            object-fit: contain;
          }
        </style>
      </head>
      <body>
        <img src="${imageUrl}" onload="window.print(); window.onafterprint = () => window.close();" />
      </body>
      </html>
    `);
    printWindow.document.close();
  });
});

});


$(document).ready(function(){
  $('.slick-carousel-video').slick({
    arrows: true,
    dots: true,
    slidesToShow: 3,
    infinite: true,

     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
         {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: true,
        }
      },
       ]
  });
});

$(document).ready(function(){
  $('.video-slideshow-section .video-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      autoplay: true,
      autoplaySpeed: 5000,
  });
});

// Contact page contact form start
$(document).ready(function () {
  var $typeSelect = $('.custom-dropdown');

  $typeSelect.on('change', function () {
    var selectedValue = $(this).val();

    // Set the attribute based on the selected value
    $(this).closest('.form-control-opetion').attr('opetionvalue', selectedValue);

    // Remove existing budget block
    $('.select-label-text-main').remove();

    // Only add budget field if "Sales inquiry" is selected
    if (selectedValue === 'Sales inquiry') {
      var budgetHTML = `
        <div class="select-label-text-main">
        <div class="select-label-text">Budget</div>
        <div class="form-control-select budget">
          <select class="select select--native is-floating" name="contact[Budget]" required>
            <option value="Unsure">Unsure</option>
            <option value="$0 - $1000">$0 - $1000</option>
            <option value="$1000 - $2500">$1000 - $2500</option>
            <option value="$2500 - $5000">$2500 - $5000</option>
            <option value="$5000 - $10000">$5000 - $10000</option>
            <option value="$10000+">$10000+</option>
          </select>
          <div class="custom-contact-form-select-icon">
            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1.5L4 4.5L7 1.5" stroke="#121212" stroke-width="2"></path>
            </svg>
          </div>
        </div>
        </div>
      `;

      // Append inside the correct parent
      $(this).closest('.custom-contact-form-select-text').append(budgetHTML);
    }

    // Handle message for "Order tracking/adjustment"
    const $messageContainer = $('.form-control-select-order');
    $messageContainer.empty();

    if (selectedValue === 'Order tracking/adjustment' || selectedValue === 'Order problem') {
      const messageText = `Please refrain from submitting multiple tickets for the same issue, as this can further delay our response time.`;

      const inputHTML = `
        <textarea readonly rows="3" name="contact[order]" style="width: 100%;">${messageText}</textarea>
      `;
      $messageContainer.append(inputHTML);
    }
  });
});
// Contact page contact form end

function set_default_menu() {
  var menu_li = $(".mega-menu");
  $(menu_li).each(function () {
    var menu_image = $(this).find(".collection_image_menu");
    $(menu_image[0]).addClass("first_menu")
    var menu_image_url = $(menu_image).data("menu-image");
    var decodedUrl = decodeURIComponent(menu_image_url);
    var menu_image_div = $(menu_image).parents("div.grid__item").closest("div.grid").find(".menu_image_div");
    $(menu_image_div).empty();
    var e = `<img src="${decodedUrl}" alt="Menu Image">`;
    $(menu_image_div).append(e);
  });
}
$(document).ready(function () {
  $("div.image_menu_li").parent().siblings("div.h5").css("padding-left", "16px");
  if ($('.menu_image_div').is(':empty')) {
  }
});

$(document).on("mouseover", ".collection_image_menu", function () {
  var menu_image = $(this).data("menu-image");
  console.log("menu_image" , menu_image)
  $(this).removeClass("first_menu")
  var decodedUrl = decodeURIComponent(menu_image);
  var menu_image_div = $(this).parents("div.grid__item").closest("div.grid").find(".menu_image_div");
  $(menu_image_div).empty();
  var e = `<img src="${decodedUrl}" alt="Menu Image">`;
  $(menu_image_div).append(e);
});
$(document).on("mouseleave", ".collection_image_menu", function () {
  var menu_image_div = $(this).parents("div.grid__item").closest("div.grid").find(".menu_image_div");
  $(menu_image_div).empty();
});

$(".mobile-nav__item.mobile-nav_item_dropdown").click(function(){
  var data_id = $(this).attr("data-id");
  console.log("data_id------------------" , data_id);
  var data_div = $('.drawer_panel.drawer_panel-next').find(`#${data_id}`);
  $(data_div).addClass("active");
  $('.drawer_panel.drawer_panel-next').css({
    "visibility": "visible",
    "opacity": "1",
    "transform": "translateX(0)"
  });
  $('.mobile-nav__link--button').removeClass("is-open");
  $('.mobile-nav__sublist .mobile-nav__sublist.collapsible-content').removeClass("is-open");
  $('.mobile-nav__sublist .mobile-nav__sublist.collapsible-content').css({
   
    "height": "0"
   });
  setTimeout(function () {
    $('.drawer__scrollable.drawer_panel').css("display", "none")
  }, 300);
  $('.drawer__scrollable.drawer_panel').css({
    "visibility": "hidden",
    "opacity": "0",
    "transform": "translateX(-400px)"
  });
});


$(".drawer__back-button").click(function(){
  $('.mobile_nav_child').removeClass("active");
  $('.drawer__scrollable.drawer_panel').css({
    "visibility": "visible",
    "opacity": "1",
    "transform": "translateX(0px)",
    "transition": "0.5s ease-in-out"
  });
  $('.mobile-nav__link--button').removeClass("is-open");
  $('.mobile-nav__sublist .mobile-nav__sublist.collapsible-content').removeClass("is-open");
  $('.mobile-nav__sublist .mobile-nav__sublist.collapsible-content').css({
   
    "height": "0"
   });
  setTimeout(function () {
    $('.drawer__scrollable.drawer_panel').css("display", "block")
  }, 300);
  $('.drawer_panel.drawer_panel-next').css({
    "visibility": "hidden",
    "opacity": "0",
    "transform": "translateX(400px)",
    "transition": "0.5s ease-in-out"
  });
});
$(".drawer__close-button").click(function(){
  $('.drawer_panel.drawer_panel-next').css({
    "visibility": "hidden",
    "opacity": "0",
    "transform": "translateX(400px)",
    "transition": "0.5s ease-in-out"
  });
  $('.drawer__scrollable.drawer_panel').css({
    "visibility": "visible",
    "opacity": "1",
    "transform": "translateX(0px)",
    "transition": "0.5s ease-in-out"
  });
  setTimeout(function () {
    $('.drawer__scrollable.drawer_panel').css("display", "block")
  }, 300);
});


$(".mobile-nav__sublist .mobile-nav__link--button").click(function(){
  var find_div = $(this).closest(".mobile-nav__item");
  console.log("==find_div==============" , find_div)
});

  $(document).ready(function () {
    $(document).on('click', '.metafield-rich_text_field ul li', function () {
    if ($(this).has('strong').length) {
      $(this).toggleClass('active');
    }
  });
  
   $(document).on('click', '.accordion-content-v2.accordion-content-features .accordion-read-more', function () {
    $('.accordion-content-v2.accordion-content-features .accordion-text-icon-main .accordion-text-icon ul li').slideDown();
    $(this).hide(); // Hide the button after click
  });
  
  $(document).on('click', '.accordion-content-v2.accordion-content-compatibility .accordion-read-more', function () {
    $('.accordion-content-v2.accordion-content-compatibility .accordion-text-icon-main .accordion-text-icon ul li').slideDown();
    $(this).hide(); // Hide the button after click
  });

  $(document).on('click', '.accordion-content-v2.accordion-content-included .accordion-read-more', function () {
    $('.accordion-content-v2.accordion-content-included .accordion-text-icon-main .accordion-text-icon ul li').slideDown();
    $(this).hide(); // Hide the button after click
  });

  $(document).on('click', '.specification-table .specifications-tabel-content .accordion-read-more', function () {
    $('.specification-table .specifications-tabel-content .metafield-rich_text_field ul').css('display','grid');
    $(this).hide(); // Hide the button after click
  });
  
});

$(document).ready(function () {
  // Instant check on page load (normal form submission)
    console.log('Scrolled to top after success message (page)');
  if ($('.note.note--success').length > 0) {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    console.log('Scrolled to top after success message (page load)');
  }

  // Interval check for dynamically added success message (AJAX)
  var checkNote = setInterval(function () {
    if ($('.note.note--success').length > 0) {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      console.log('Scrolled to top after success message (AJAX)');
      clearInterval(checkNote);
    }
  }, 1000);

  // Optional: stop checking after 5 seconds
  setTimeout(function () {
    clearInterval(checkNote);
  }, 5000);
});

// paypal app text
$(document).ready(function () {
  const target = document.body;

  const observer = new MutationObserver(function () {
    var paypalElement = $('.paypal-text-main');
    if (paypalElement.length) {
      paypalElement.detach();
      $('.paypal-app-text').prepend(paypalElement);
      observer.disconnect(); // Stop observing after moving the element
    }
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
});

$(".black_friday_offer_close").click(function(){
  $(".black_friday_offer").hide();
});